<script lang="ts">
    import Badge from "../badge/badge.svelte";

    interface Props {
        label: string;
        color: string;
        class?: string;
    }

    let { label, color, class: className }: Props = $props();

    // Map color names to full Tailwind classes (required for Tailwind to detect them at build time)
    const colorMap: Record<string, string> = {
        blue: 'bg-event-blue text-event-blue-foreground border-event-blue-border',
        gray: 'bg-event-gray text-event-gray-foreground border-event-gray-border',
        purple: 'bg-event-purple text-event-purple-foreground border-event-purple-border',
        red: 'bg-event-red text-event-red-foreground border-event-red-border',
        green: 'bg-event-green text-event-green-foreground border-event-green-border',
        yellow: 'bg-event-yellow text-event-yellow-foreground border-event-yellow-border',
        orange: 'bg-event-orange text-event-orange-foreground border-event-orange-border',
        cyan: 'bg-event-cyan text-event-cyan-foreground border-event-cyan-border',
        emerald: 'bg-event-emerald text-event-emerald-foreground border-event-emerald-border',
        lime: 'bg-event-lime text-event-lime-foreground border-event-lime-border',
        teal: 'bg-event-teal text-event-teal-foreground border-event-teal-border',
        indigo: 'bg-event-indigo text-event-indigo-foreground border-event-indigo-border',
        violet: 'bg-event-violet text-event-violet-foreground border-event-violet-border',
        pink: 'bg-event-pink text-event-pink-foreground border-event-pink-border',
        rose: 'bg-event-rose text-event-rose-foreground border-event-rose-border',
        amber: 'bg-event-amber text-event-amber-foreground border-event-amber-border',
        magenta: 'bg-event-magenta text-event-magenta-foreground border-event-magenta-border',
        slate: 'bg-event-slate text-event-slate-foreground border-event-slate-border',
    };

    let colorClasses = $derived(colorMap[color] ?? colorMap.gray);
</script>

<Badge variant="outline" class="{colorClasses} {className ?? ''} font-responsive">
    {label}
</Badge>
